export enum SOURCE {
    PABOL = 'pabol',
    DIRECT_SHOPPER = 'direct-shopper',
    AGENT = 'agent',
    EMBEDDED_QUOTE = 'embedded',
    EMAIL = 'email',
    SALESFORCE = 'salesforce',
    CHANGE_APP = 'change-app',
    EMBEDDED_AGENT = 'embedded-agent'
}

export const sourceMap = new Map<string, SOURCE>([
    ['PABOL_DIRECT', SOURCE.PABOL],
    ['DIRECT', SOURCE.DIRECT_SHOPPER],
    ['PRODUCER_ENTERED', SOURCE.AGENT],
    ['QUOTED_SALE', SOURCE.EMBEDDED_QUOTE],
    ['DIRECT', SOURCE.EMAIL],
    ['DIRECT', SOURCE.SALESFORCE],
    ['WEB_QUOTE', SOURCE.CHANGE_APP],
]);

export const sourcesToRecommend: SOURCE[] = [SOURCE.AGENT, SOURCE.EMAIL, SOURCE.SALESFORCE];

// EMBEDDED_AGENT normally behaves like an agent enrolling directly, but when the agent chooses to
// email the quote to their client on the applicant-information form, it should act like SOURCE.EMAIL
// (recommend/send-to-client buttons instead of enroll/save).
export function isEmbeddedAgentEmailDelivery(source?: SOURCE, deliveryMethod?: string): boolean {
    return source === SOURCE.EMBEDDED_AGENT && deliveryMethod === 'email';
}

export function actsAsEmailSource(source?: SOURCE, deliveryMethod?: string): boolean {
    return source === SOURCE.EMAIL || isEmbeddedAgentEmailDelivery(source, deliveryMethod);
}
